<template>
<v-card
    :outlined="outlined"
    :color="backgroundColor"
    :height="100">
    <div class="d-flex d-flex-no-wrap align-center" style="height: 100%">
        <v-avatar
            class="ma-3"
            size="50"
            tile>
            <v-icon size="50" :color="color">{{icon}}</v-icon>
        </v-avatar>
        <div>
            <div :style="{color: contentColor}">{{title}}</div>
            <div :style="{color: contentColor}" class="text-h4">{{value}}</div>
        </div>
    </div>
</v-card>
</template>

<script>
export default {
    name: "DashboardBox",
    props: [
        "color",
        "value",
        "title",
        "icon",
        "outlined",
        "background-color",
        "contentColor"
    ]
}
</script>